// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Jaa-z","narrowOptionButtons":"Kaa-z","noOptions":"Laa-z"};